import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import Iframe from "react-iframe";
import { openProposalUrl } from "ProposalAction";
import { DOMAIN_NAME } from "Constants";
import LocaleStrings from "Languages";

class ProposalUrl extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    var formnumber = this.props.showProposalUrlModal.formnumber;
    let seocode =
      this.props.eventDetails && this.props.eventDetails.seocode
        ? this.props.eventDetails.seocode
        : "not-found-seocode";
    var websiteurl = `https://${seocode}.${DOMAIN_NAME}/t/proposals/${formnumber}`;
    // console.log("URL =", websiteurl);

    this.state = {
      websiteurl,
    };
  }

  closeModal() {
    this.props.openProposalUrl(false, "");
  }

  render() {
    return (
      <Modal
        className="modal-container"
        show={this.props.showProposalUrlModal.showModal === true ? true : false}
        animation={true}
        keyboard={false}
        backdrop="static"
        // dialogClassName="ticket-url"
        dialogClassName="modal-lg"
      >
        <Modal.Header>
          <div className="import-modal-title">View Abstract Form</div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.closeModal()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="ticket-url-container">
            <Iframe
              url={this.state.websiteurl}
              width="100%"
              height="100%"
              id="webbrowser"
              display="initial"
              position="relative"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-custom-white"
            bsStyle=""
            onClick={this.closeModal}
          >
            {LocaleStrings.button_close}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showProposalUrlModal: state.showProposalUrlModal,
  };
}

export default connect(mapStateToProps, { openProposalUrl })(ProposalUrl);
